import React, { Component } from 'react';
import "../styles/ResultBook.css";

class ResultBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fitContent: false,
    }
  }

  expand = () => {
    // console.log('click')
    this.setState({fitContent: !this.state.fitContent});
  }

  renderText = () => {
    if (!this.props.book.description) return <p>This book has no description</p>;

    let textArr = this.props.book.description.replace('...', '.').split('.'); // /./
    return textArr.map((parapgraph, i) => {
      if (i === 0) return <p key={i+parapgraph.substring(0, 10)} className='DescriptionParagraphBold'>{parapgraph+'.'}</p>
      else return <p key={i+parapgraph.substring(0, 10)} className='DescriptionParagraph'>{parapgraph+'.'}</p>
    })
  }

  renderTier = () => {
    if (this.props.book.tier === 1) return "Top Match!";
    else if (this.props.book.tier === 2) return "Great Match!";
    else return "";
  }
  
  render() {
    let {title, author, image, pageCount, buyLink, rank, published} = this.props.book;
    // let bookStyle = {heigth: '200px'};
    // if (this.state.fitContent) bookStyle = {heigth: 'fitContent'};

    return (
      <div style={this.state.fitContent ? { height: 'fit-content'} : {}} className="ResultBook">

        <div className="ResultBookCover">
          <img className='ResultBookContentPicture' alt='cover preview' src={image}/>
        </div>

        <div className="ResultBookContent">

          <div className="ResultBookContentHeader">
            <div className="ResultBookHeaderInfo">
              <div className="ResultBookHeaderInfoTitle">{title}</div>
              <div className="ResultBookHeaderInfoAuthor">{'by ' + author}</div>
            </div>
            <div className="ResultBookHeaderStats">
              <div className='ResultBookHeaderScore'>{this.renderTier()}</div>
              <div className="ResultBookHeaderRank">{"Rank: " + rank}</div>
            </div>
          </div>

          
          <div className="ResultBookContentDescription">
            {this.renderText()}
          </div>

          <div className="ResultBookContentFooter">
            <div className="ResultBookFooterLink"><a target="_blank" href={buyLink}>More info</a></div>
            <button className="expandButton" onClick={() => this.expand()}>EXPAND</button>
            <div className="ResultBookFooterInfo">
              <div className="ResultBookFooterInfoPublished">{'Published: '+published}</div>
              <div className="ResultBookFooterInfoPages">{'Pages: ' + pageCount}</div>
            </div>
          </div>

        </div>

      </div>
    )
  }
}

export default ResultBook;


// WEBPACK FOOTER //
// ./src/components/ResultBook.js